// extracted by mini-css-extract-plugin
module.exports = {"col":"styles_col__mvS3C","active":"styles_active__2iD6S","title":"styles_title__2KNdw","withKey":"styles_withKey__2cVSO"};